var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#CFEBCE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 72,
    height: 72,
    rx: 36,
    stroke: "#CFEBCE",
    strokeOpacity: 0.2,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3077 31.9231C30.3077 30.3522 30.9317 28.8456 32.0425 27.7348C33.1533 26.624 34.6599 26 36.2308 26C37.8017 26 39.3082 26.624 40.419 27.7348C41.5298 28.8456 42.1538 30.3522 42.1538 31.9231C42.1538 33.494 41.5298 35.0005 40.419 36.1113C39.3082 37.2221 37.8017 37.8461 36.2308 37.8461C34.6599 37.8461 33.1533 37.2221 32.0425 36.1113C30.9317 35.0005 30.3077 33.494 30.3077 31.9231ZM26 50.2307C26 47.5174 27.0779 44.9151 28.9965 42.9965C30.9152 41.0779 33.5174 40 36.2308 40C38.9441 40 41.5464 41.0779 43.465 42.9965C45.3837 44.9151 46.4615 47.5174 46.4615 50.2307V50.2351L46.4601 50.4059C46.4571 50.5885 46.4076 50.7674 46.3164 50.9256C46.2253 51.0839 46.0953 51.2163 45.9389 51.3105C43.0085 53.0752 39.6515 54.0052 36.2308 54C32.6812 54 29.3586 53.0178 26.5241 51.3105C26.3674 51.2165 26.2372 51.0841 26.1457 50.9259C26.0543 50.7676 26.0046 50.5887 26.0014 50.4059L26 50.2307ZM49.6923 33.5385C49.6923 33.2528 49.5788 32.9789 49.3769 32.777C49.1749 32.575 48.901 32.4615 48.6154 32.4615C48.3298 32.4615 48.0558 32.575 47.8539 32.777C47.6519 32.9789 47.5385 33.2528 47.5385 33.5385V36.7692H44.3077C44.0221 36.7692 43.7482 36.8827 43.5462 37.0846C43.3442 37.2866 43.2308 37.5605 43.2308 37.8461C43.2308 38.1318 43.3442 38.4057 43.5462 38.6076C43.7482 38.8096 44.0221 38.9231 44.3077 38.9231H47.5385V42.1538C47.5385 42.4395 47.6519 42.7134 47.8539 42.9153C48.0558 43.1173 48.3298 43.2308 48.6154 43.2308C48.901 43.2308 49.1749 43.1173 49.3769 42.9153C49.5788 42.7134 49.6923 42.4395 49.6923 42.1538V38.9231H52.9231C53.2087 38.9231 53.4826 38.8096 53.6846 38.6076C53.8865 38.4057 54 38.1318 54 37.8461C54 37.5605 53.8865 37.2866 53.6846 37.0846C53.4826 36.8827 53.2087 36.7692 52.9231 36.7692H49.6923V33.5385Z",
    fill: "#00848D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProfile);
export default __webpack_public_path__ + "static/media/create_profile.1fbf9489248268d8bce8a1528dd3080d.svg";
export { ForwardRef as ReactComponent };